import { UPDATE_STORE_REQUEST, UPDATE_STORE_SUCCESS, UPDATE_STORE_FAILURE, UPDATE_STORE_RESET } from "../../actions";
const initialState = {
    updateData: [],
    isLoading: false,
    error: null,
};
const reducer = (state = initialState, action) => {
    switch (action.type) {
        case UPDATE_STORE_REQUEST:
            return Object.assign(Object.assign({}, state), { isLoading: true, error: null });
        case UPDATE_STORE_SUCCESS:
            return Object.assign(Object.assign({}, state), { updateData: action.payload, isLoading: false, error: null });
        case UPDATE_STORE_FAILURE:
            return Object.assign(Object.assign({}, state), { isLoading: false, error: action.payload });
        case UPDATE_STORE_RESET:
            return Object.assign(Object.assign({}, state), { isLoading: false, updateData: null, error: null });
        default:
            return state;
    }
};
export default reducer;
